import(/* webpackMode: "eager", webpackExports: ["BaseAppBar"] */ "/home/mraof/.cache/yay/hedgedoc2/src/hedgedoc-2.0.0-alpha.3/frontend/src/components/layout/app-bar/base-app-bar.tsx");
